import React from 'react';

/* Display an animated loading indicator */

const LoadingSpinner = () => {
  
  return (

    <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: '300px' }}>
      <div className="spinner-border text-primary align-self-center" role="status" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>

  );
};

export default LoadingSpinner;